import React, {Fragment} from 'react';
import ContributionItem from "../../atoms/cards/ContributionItem";
import {Contribution} from "../../../utils/types";

interface Props {
    contributions: Contribution[],
    showWaveFormDefault?: boolean,
}

const ContributionItems = ({contributions, showWaveFormDefault}: Props) => {
    return (
        <Fragment>
            {/*TODO: Use Virtualized list such as React Window and Autosize*/}
            {
                contributions.map((contribution, index) => {
                    return (
                        <ContributionItem key={index} container_id={`${contribution.file_url.split('/')[1]}-${index}`} contribution={contribution} />
                    )})
            }
        </Fragment>
    );
};

export default ContributionItems;